module.exports = __webpack_public_path__ + "img/acamp.5befaee.svg";